import { ITariff } from "@interfaces/user/tariff";
import { authApi } from "@RTKQuery/basic";

const tariffsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getUserTariffs: build.query<ITariff[], void>({
            query: () => "tariffs/get_personal_prices",
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetUserTariffsQuery
} = tariffsAuthApi;